//#region INTERFACE ILineColourOption
export interface ILineColourOption {
  description: string;
  value: string;
  code?: number;
}

//#endregion

//#region TYPE TLineColour
export type TLineColour = Record<string, ILineColourOption>;
//#endregion
